import { useQuery } from '@tanstack/react-query';
import { queryOptionsMsr2AddTitleAvailable } from '../api/embed/msr2EmbedApi';

export const useMsr2AddTitleAvailable = (workspaceId?: string) =>
  useQuery(queryOptionsMsr2AddTitleAvailable(workspaceId));
